import { yupResolver } from "@hookform/resolvers/yup";
import React from "react";
import { useForm } from "react-hook-form";
import { SdsForm } from "soft_digi";
import { SdsFormElementProps } from "soft_digi/dist/sdforms/SdsFromInterFace";
import * as Yup from "yup";
import { LEAVE_TYPES_URLS } from "../../api/SettingsUrls";
import { useSiteContext } from "../../contexts/SiteProvider";
import { showAlertAutoClose } from "../../services/notifyService";
import { post } from "../../services/smartApiService";

interface HeaderProps {
  loadTableData: () => void;
  data: any;
}

const schema = Yup.object({
  type_name: Yup.string()
    .required("Required"),
  short_name: Yup.string()
    .required("Required")
  ,
  max_days: Yup.number()
    .required("Required")
    .positive("Max Days must be a positive number")
    .integer("Max Days must be an integer")
    .min(1, "Max Days must be at least 1")
    .max(365, "Max Days cannot exceed 365"),
  max_days_occasion: Yup.number()
    .required("Required")
    .positive("Must be a positive number")
    .integer("Must be an integer")
    .max(30, "Cannot exceed 30 days"),
  max_days_month: Yup.number()
    .required("Required")
   ,
  leave_accumulation: Yup.object()
    .required("Required")
    .oneOf(["1", "2", "3", "4"], "Invalid Leave Renewal option"),
  carry_forward: Yup.object()
    .required("Required")
    .oneOf(["1", "2"], "Invalid Carry Forward option"),
  earned_leave: Yup.object()
    .required("Required")
    .oneOf(["1", "2"], "Invalid Earned Leave option"),
});


const LeaveTypesForm: React.FC<HeaderProps> = ({ loadTableData, data }) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: data,
  });
  const { closeModal } = useSiteContext();

  const onSubmit = (formData: any) => {
    let url = LEAVE_TYPES_URLS.INSERT;
    if (data.ID !== undefined) {
      formData["id"] = data.ID;
      url = LEAVE_TYPES_URLS.UPDATE;
    }

    const subscription = post(url, formData).subscribe((response) => {
      showAlertAutoClose("Data Saved Successfully", "success");
      closeModal();
      loadTableData();
    });
    return () => subscription.unsubscribe();
  };

  const elements: SdsFormElementProps[] = [
    {
      type: "TEXT_BOX",
      width: 6,
      name: "type_name",
      element: {
        label: "Name of leave type",
        isRequired: true,
      },
    },
    {
      type: "TEXT_BOX",
      width: 6,
      name: "short_name",
      element: {
        label: "Enter Short Name",
        isRequired: true,
        placeHolder:"Ex: CL,ML,EL"
      },
    },
    {
      type: "TEXT_BOX",
      width: 6,
      name: "max_days",
      element: {
        label: "Number of Leaves",
        isRequired: true,
      },
    },
    {
      type: "SELECT_BOX",
      width: 6,
      name: "leave_accumulation",
      element: {
        label: "Leave Renewal",
        options: [
          { value: "1", label: "Monthly" },
          { value: "2", label: "Quarterly" },
          { value: "3", label: "Half Yearly" },
          { value: "4", label: "Yearly" },
        ],
        type: "radio",
        isRequired: true,
      },
    },
    
    {
      type: "CHECK_RADIO",
      width: 6,
      name: "carry_forward",
      element: {
        label: "Carry-forward allowed",
        options: [
          { value: "1", label: "Yes" },
          { value: "2", label: "No" },
        ],
        type: "radio",
        isRequired: true,
        isMulti: true,
      },
    },
    {
      type: "CHECK_RADIO",
      width: 6,
      name: "earned_leave",
      element: {
        label: "Is Earned Leave",
        options: [
          { value: "1", label: "Yes" },
          { value: "2", label: "No" },
        ],
        type: "radio",
        isRequired: true,
        isMulti: true,
      },
    },
    {
      type: "TEXT_BOX",
      width: 6,
      name: "max_days_occasion",
      element: {
        label: "Number of days allotted per Occasion",
        isRequired: true,
      },
    },
    {
      type: "TEXT_BOX",
      width: 6,
      name: "max_days_month",
      element: {
        label: "Number of days allotted per Month",
        isRequired: true,
      },
    },
    {
      type: "BUTTON",
      width: 12,
      name: "submit_button",
      class_name: "has-text-right",
      element: {
        classList: ["button", "smart-action-button"],
        label: data.ID ? "Update" : "Add",
        onClick: handleSubmit(onSubmit),
      },
    },
  ];

  return (
    <div className="sd-hims-input">
      <SdsForm elements={elements} errors={errors} control={control} />
    </div>
  );
};

export default LeaveTypesForm;
